export default "__VITE_ASSET__32e3fdc2__"